import { useReducer } from 'react';
import { List } from 'immutable';

// fields data structure
import { REGISTRATION_FIELDS } from '../fields';

const initialState = REGISTRATION_FIELDS;

const reducer = (state, { type, payload }) => {
  const {
    key,
    value,
    metadata,
    error = '',
    fieldsToUpdate = {},
    signUpErrors = new List(),
    redirectUrl,
  } = payload;

  const signUpErrorsMap = signUpErrors.reduce((signUpErrorsObj, err) => ({
    ...signUpErrorsObj,
    [err.field]: err.messages[0]
  }), {});

  switch (type) {
    case 'update':
      return {
        ...state,
        [key]: {
          ...state[key],
          ...(metadata !== undefined) && { metadata },
          ...(value !== undefined) && { value },
          ...(error !== undefined) && { error },
          ...(redirectUrl ? { redirectUrl } : { redirectUrl: ''}),
        }
      };
    case 'batch-update':
      return Object.keys(fieldsToUpdate)
        .reduce((update, fieldKey) => ({
          ...update,
          [fieldKey]: {
            ...update[fieldKey],
            ...(fieldsToUpdate[fieldKey].metadata !== undefined) && {
              metadata: fieldsToUpdate[fieldKey].metadata
            },
            ...(fieldsToUpdate[fieldKey].value !== undefined) && {
              value: fieldsToUpdate[fieldKey].value
            },
            ...(fieldsToUpdate[fieldKey].error !== undefined) && {
              error: fieldsToUpdate[fieldKey].error
            },
          }
        }), state);
    case 'update-errors':
      return Object.keys(state).reduce((stateUpdate, fieldKey) => ({
        ...stateUpdate,
        [fieldKey]: {
          ...stateUpdate[fieldKey],
          error: signUpErrorsMap[fieldKey] || ''
        }
      }), { ...state });
    default:
      return state;
  }
};

const useFieldsReducer = () => useReducer(reducer, initialState);

export default useFieldsReducer;
